import { useEffect, useState } from "react";

/**
 * Hook для определения системной темы устройства
 * Отслеживает изменения prefers-color-scheme и автоматически обновляет тему
 *
 * @returns {boolean} true если системная тема тёмная, false если светлая
 */
export const useSystemTheme = (): boolean => {
  const [isDark, setIsDark] = useState(() => {
    // Проверяем системную тему при инициализации
    if (typeof window !== "undefined" && window.matchMedia) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    return false;
  });

  useEffect(() => {
    // Проверка поддержки matchMedia
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    // Обработчик изменения темы
    const handleChange = (event: MediaQueryListEvent) => {
      setIsDark(event.matches);
    };

    // Подписка на изменения (современный API)
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else {
      // Fallback для старых браузеров
      mediaQuery.addListener(handleChange);
    }

    // Cleanup
    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  return isDark;
};
